var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Selector = require('../selector');

var Placeholder = /*#__PURE__*/function (_Selector) {
  "use strict";

  _inherits(Placeholder, _Selector);

  var _super = _createSuper(Placeholder);

  function Placeholder() {
    _classCallCheck(this, Placeholder);

    return _super.apply(this, arguments);
  }

  _createClass(Placeholder, [{
    key: "possible",
    value:
    /**
     * Add old mozilla to possible prefixes
     */
    function possible() {
      return _get(_getPrototypeOf(Placeholder.prototype), "possible", this).call(this).concat(['-moz- old', '-ms- old']);
    }
    /**
     * Return different selectors depend on prefix
     */

  }, {
    key: "prefixed",
    value: function prefixed(prefix) {
      if (prefix === '-webkit-') {
        return '::-webkit-input-placeholder';
      }

      if (prefix === '-ms-') {
        return '::-ms-input-placeholder';
      }

      if (prefix === '-ms- old') {
        return ':-ms-input-placeholder';
      }

      if (prefix === '-moz- old') {
        return ':-moz-placeholder';
      }

      return "::".concat(prefix, "placeholder");
    }
  }]);

  return Placeholder;
}(Selector);

Placeholder.names = ['::placeholder'];
module.exports = Placeholder;